import gql from 'graphql-tag';
import { ECHELON_INFO_FRAGMENT } from '../echelon/fragment';
import { ENSEIGNE_INFO_FRAGMENT } from '../enseigne/fragment';
import { ENTITY_FRAGMENT } from './fragment';

export const GET_ENTITY = gql`
  query GetEntity($entityId: Int!) {
    entity(entityId: $entityId) {
      ...EntityInfo
      managers {
        id
      }
      echelon {
        ...EchelonInfo
      }
      enseigne {
        ...EnseigneInfo
      }
      parentEntity {
        ...EntityInfo
      }
      reseau {
        ...EntityInfo
      }
    }
  }
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
  ${ENSEIGNE_INFO_FRAGMENT}
`;

export const GET_ALL_ENTITIES = gql`
  query AllEntities($input: AllEntitiesInput) {
    allEntities(input: $input) {
      totalCount
      entities {
        ...EntityInfo
        managers {
          id
        }
        echelon {
          ...EchelonInfo
        }
        enseigne {
          ...EnseigneInfo
        }
        parentEntity {
          ...EntityInfo
        }
        reseau {
          ...EntityInfo
        }
      }
    }
  }
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
  ${ENSEIGNE_INFO_FRAGMENT}
`;

export const GET_MINIMAL_ENTITIES = gql`
  query MinimalEntities($input: AllEntitiesInput) {
    allEntities(input: $input) {
      totalCount
      entities {
        id
        name
      }
    }
  }
`;

export const GET_ALL_ENTITIES_FOR_USERS = gql`
  query AllEntitiesForUsers($input: AllEntitiesInput) {
    allEntities(input: $input) {
      totalCount
      entities {
        id
        name
        managers {
          id
        }
        echelon {
          ...EchelonInfo
        }
      }
    }
  }
  ${ECHELON_INFO_FRAGMENT}
`;
